export default "__VITE_ASSET__Bm5_0bXA__"